const logoLinks = {
  logado: '/paciente/home',
  deslogado: '/paciente'
}

export default logoLinks
